import Vue from 'vue'
import App from './App.vue'

const _ = require('lodash');

var initRef = _.debounce(function() {
  var version = "0.2.8";
  console.log("IPA grid " + version + " loaded.");
}, 1);

initRef();

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
}).$mount('#app-flipchart');